import { h } from 'vue';

interface IndentProps {
  prefixCls: string;
  level?: number;
  isStart?: boolean[];
  isEnd?: boolean[];
}

const Indent = ({ prefixCls, level, isStart, isEnd }: IndentProps) => {
  const baseClassName = `${prefixCls}__indent-unit`;
  const list = [];

  for (let i = 0; i < level!; i += 1) {
    list.push(
      h('span', {
        key: i,
        class: {
          [baseClassName]: true,
          [`${baseClassName}--start`]: isStart![i],
          [`${baseClassName}--end`]: isEnd![i]
        }
      })
    );
  }

  return h('span', { 'aria-hidden': true, class: `${prefixCls}__indent` }, list);
};

export default Indent;
